// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Landing Page Styles */
.landing-page {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
  line-height: 1.6;
  margin-left: -40px;
  margin-right: -40px;
  padding-left: 40px;
  padding-right: 40px;
}

.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Header */
.landing-header {
  background-color: #ffffff;
  padding: 15px 0;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.landing-header .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.landing-header h1 {
  margin: 0;
  font-size: 1.8em;
  color: #007bff; /* Primary color */
}

.landing-header nav .btn {
  padding: 8px 20px;
  font-size: 1em;
}

/* Hero Section */
.hero-section {
  background-color: #f8f9fa; /* Light background */
  padding: 60px 0;
  text-align: center;
}

.hero-section h2 {
  font-size: 2.5em;
  margin-bottom: 20px;
  color: #343a40;
}

.hero-section p {
  font-size: 1.1em;
  max-width: 700px;
  margin: 0 auto 30px auto;
  color: #555;
}

/* Benefits Section */
.benefits-section {
  padding: 60px 0;
}

.benefits-section h2 {
  text-align: center;
  font-size: 2.2em;
  margin-bottom: 40px;
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.benefit-card {
  background-color: #ffffff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.benefit-card h3 {
  font-size: 1.5em;
  margin-top: 15px;
  margin-bottom: 15px;
  color: #007bff;
}

.benefit-card.customer h3 {
  color: #28a745; /* Success color for customer benefits */
}

.benefit-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
  display: inline-block; /* Center list items */
}

.benefit-card ul li {
  margin-bottom: 8px;
  position: relative;
  padding-left: 20px;
}

.benefit-card ul li::before {
  content: '✓'; /* Checkmark */
  position: absolute;
  left: 0;
  color: #28a745; /* Green checkmark */
  font-weight: bold;
}

.benefit-icon {
  font-size: 2.5em;
  margin-bottom: 10px;
  color: #007bff;
}

.benefit-card.customer .benefit-icon {
  color: #28a745;
}


/* Features Section */
.features-section {
  background-color: #f8f9fa;
  padding: 60px 0;
}

.features-section h2 {
  text-align: center;
  font-size: 2.2em;
  margin-bottom: 40px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
}

.feature-card {
  background-color: #ffffff;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  text-align: center;
}

.feature-icon {
  font-size: 2.2em;
  margin-bottom: 15px;
  color: #6c757d; /* Secondary color */
}

.feature-card h3 {
  font-size: 1.4em;
  margin-bottom: 10px;
}

.feature-card p {
  font-size: 0.95em;
  color: #555;
}

/* Footer */
.landing-footer {
  background-color: #343a40; /* Dark background */
  color: #f8f9fa;
  text-align: center;
  padding: 20px 0;
  margin-top: 40px;
}

.landing-footer p {
  margin: 0;
}

/* Placeholder Icon Style */
.placeholder-icon {
  display: inline-block;
  /* Add specific styles if needed, e.g., width, height, background */
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .landing-header .container {
    flex-direction: column;
    text-align: center;
  }
  .landing-header h1 {
    margin-bottom: 10px;
  }
  .benefits-grid, .features-grid {
    grid-template-columns: 1fr; /* Stack cards on smaller screens */
  }
}

/* Basic Button Styling (assuming Bootstrap is not globally applied here) */
.btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  text-decoration: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.btn-primary:hover {
  color: #fff;
  background-color: #0056b3;
  border-color: #004085;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LandingPage.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,4DAA4D;EAC5D,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,eAAe;EACf,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc,EAAE,kBAAkB;AACpC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB,EAAE,qBAAqB;EAChD,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc,EAAE,wCAAwC;AAC1D;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,qBAAqB,EAAE,sBAAsB;AAC/C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY,EAAE,cAAc;EAC5B,kBAAkB;EAClB,OAAO;EACP,cAAc,EAAE,oBAAoB;EACpC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc,EAAE,oBAAoB;AACtC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,mEAAmE;AACrE;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,0BAA0B,EAAE,mCAAmC;EACjE;AACF;;AAEA,2EAA2E;AAC3E;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,qIAAqI;AACvI;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":["/* General Landing Page Styles */\n.landing-page {\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  color: #333;\n  line-height: 1.6;\n  margin-left: -40px;\n  margin-right: -40px;\n  padding-left: 40px;\n  padding-right: 40px;\n}\n\n.container {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n/* Header */\n.landing-header {\n  background-color: #ffffff;\n  padding: 15px 0;\n  border-bottom: 1px solid #e0e0e0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.landing-header .container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.landing-header h1 {\n  margin: 0;\n  font-size: 1.8em;\n  color: #007bff; /* Primary color */\n}\n\n.landing-header nav .btn {\n  padding: 8px 20px;\n  font-size: 1em;\n}\n\n/* Hero Section */\n.hero-section {\n  background-color: #f8f9fa; /* Light background */\n  padding: 60px 0;\n  text-align: center;\n}\n\n.hero-section h2 {\n  font-size: 2.5em;\n  margin-bottom: 20px;\n  color: #343a40;\n}\n\n.hero-section p {\n  font-size: 1.1em;\n  max-width: 700px;\n  margin: 0 auto 30px auto;\n  color: #555;\n}\n\n/* Benefits Section */\n.benefits-section {\n  padding: 60px 0;\n}\n\n.benefits-section h2 {\n  text-align: center;\n  font-size: 2.2em;\n  margin-bottom: 40px;\n}\n\n.benefits-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 30px;\n}\n\n.benefit-card {\n  background-color: #ffffff;\n  padding: 30px;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.benefit-card h3 {\n  font-size: 1.5em;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  color: #007bff;\n}\n\n.benefit-card.customer h3 {\n  color: #28a745; /* Success color for customer benefits */\n}\n\n.benefit-card ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n  display: inline-block; /* Center list items */\n}\n\n.benefit-card ul li {\n  margin-bottom: 8px;\n  position: relative;\n  padding-left: 20px;\n}\n\n.benefit-card ul li::before {\n  content: '✓'; /* Checkmark */\n  position: absolute;\n  left: 0;\n  color: #28a745; /* Green checkmark */\n  font-weight: bold;\n}\n\n.benefit-icon {\n  font-size: 2.5em;\n  margin-bottom: 10px;\n  color: #007bff;\n}\n\n.benefit-card.customer .benefit-icon {\n  color: #28a745;\n}\n\n\n/* Features Section */\n.features-section {\n  background-color: #f8f9fa;\n  padding: 60px 0;\n}\n\n.features-section h2 {\n  text-align: center;\n  font-size: 2.2em;\n  margin-bottom: 40px;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 30px;\n}\n\n.feature-card {\n  background-color: #ffffff;\n  padding: 25px;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);\n  text-align: center;\n}\n\n.feature-icon {\n  font-size: 2.2em;\n  margin-bottom: 15px;\n  color: #6c757d; /* Secondary color */\n}\n\n.feature-card h3 {\n  font-size: 1.4em;\n  margin-bottom: 10px;\n}\n\n.feature-card p {\n  font-size: 0.95em;\n  color: #555;\n}\n\n/* Footer */\n.landing-footer {\n  background-color: #343a40; /* Dark background */\n  color: #f8f9fa;\n  text-align: center;\n  padding: 20px 0;\n  margin-top: 40px;\n}\n\n.landing-footer p {\n  margin: 0;\n}\n\n/* Placeholder Icon Style */\n.placeholder-icon {\n  display: inline-block;\n  /* Add specific styles if needed, e.g., width, height, background */\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .landing-header .container {\n    flex-direction: column;\n    text-align: center;\n  }\n  .landing-header h1 {\n    margin-bottom: 10px;\n  }\n  .benefits-grid, .features-grid {\n    grid-template-columns: 1fr; /* Stack cards on smaller screens */\n  }\n}\n\n/* Basic Button Styling (assuming Bootstrap is not globally applied here) */\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  color: #212529;\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n  text-decoration: none;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff;\n}\n\n.btn-primary:hover {\n  color: #fff;\n  background-color: #0056b3;\n  border-color: #004085;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
